export default "__VITE_ASSET__DlilyoFF__"